import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US';

export const ImageFilenameTooltip = props => (
  <div>
    <IntlProvider locale='en' messages={enUSmessage}>
      <FormattedMessage id='tooltips.image.upload.filename' />
    </IntlProvider>
  </div>
);

export const ImageNameTooltip = props => (
  <div>
    <IntlProvider locale='en' messages={enUSmessage}>
      <FormattedMessage id='tooltips.image.upload.name' />
    </IntlProvider>
  </div>
);

export const ImageSourceTooltip = props => (
  <div>
    <IntlProvider locale='en' messages={enUSmessage}>
      <FormattedMessage id='tooltips.image.upload.source' />
    </IntlProvider>
  </div>
);

export const ImageAltAttributeTooltip = props => (
  <div>
    <IntlProvider locale='en' messages={enUSmessage}>
      <FormattedMessage id='tooltips.image.upload.altAttribute' />
    </IntlProvider>
  </div>
);

export const ImageLinkTooltip = props => (
  <div>
    <IntlProvider locale='en' messages={enUSmessage}>
      <FormattedMessage id='tooltips.image.upload.link' />
    </IntlProvider>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/images/tooltips/image-edit-modal-tooltips.jsx